import { motion } from 'framer-motion'
import { products } from '../data/mockData'
import { Leaf } from 'lucide-react'
import ProductCard, { EcothermHero } from '../compenents/ProductCard'

const Products = () => {
  return (
    <div className="min-h-screen pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6">
            <Leaf className="w-10 h-10 text-green-600" />
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-gradient mb-6">Nos Produits Naturels</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            ECOTHERM utilise uniquement des ingrédients 100% naturels pour créer des solutions d'isolation écologiques et performantes. Chaque composant est soigneusement sélectionné pour ses propriétés uniques et son respect de l'environnement.
          </p>
        </motion.div>
        <EcothermHero/>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <motion.div
              key={product.id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <ProductCard product={product} />
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="mt-20 bg-gradient-to-br from-green-50 to-green-100 rounded-3xl p-12 moroccan-pattern"
        >
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Pourquoi Nos Produits Sont Uniques</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
              <div className="bg-white rounded-xl p-6 shadow-md">
                <div className="text-4xl font-bold text-green-600 mb-2">100%</div>
                <p className="text-gray-700 font-semibold">Matériaux Naturels</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-md">
                <div className="text-4xl font-bold text-green-600 mb-2">0</div>
                <p className="text-gray-700 font-semibold">Substances Nocives</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-md">
                <div className="text-4xl font-bold text-green-600 mb-2">0</div>
                <p className="text-gray-700 font-semibold">Besoin d'Eau</p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  )
}

export default Products